// Site-initial favicon placeholders — never real logos (design DNA).
const FAV = [
  'var(--fav-1)',
  'var(--fav-2)',
  'var(--fav-3)',
  'var(--fav-4)',
  'var(--fav-5)',
  'var(--fav-6)',
  'var(--fav-7)',
  'var(--fav-8)',
];

export interface FaviconProps {
  letter?: string;
  /** picks --fav-1…8 */
  index?: number;
  size?: number;
  ring?: string;
}

export function Favicon({ letter = 'A', index = 0, size = 19, ring = 'var(--surface-1)' }: FaviconProps) {
  const background = FAV[index % FAV.length] ?? 'var(--fav-1)';
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.27),
        background,
        border: '1.5px solid ' + ring,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'var(--font-body)',
        fontSize: Math.round(size * 0.47),
        fontWeight: 600,
        color: '#fff',
        flexShrink: 0,
      }}
    >
      {letter}
    </span>
  );
}

export interface FaviconStackProps {
  letters?: string[];
  /** renders a trailing +N chip */
  overflow?: number;
  size?: number;
}

export function FaviconStack({ letters = ['A', 'B', 'C'], overflow = 0, size = 19 }: FaviconStackProps) {
  const inset = Math.round(size * 0.37);
  return (
    <span style={{ display: 'inline-flex' }}>
      {letters.map((l, i) => (
        <span key={i} style={{ marginLeft: i === 0 ? 0 : -inset, display: 'inline-flex' }}>
          <Favicon letter={l} index={i} size={size} />
        </span>
      ))}
      {overflow > 0 && (
        <span
          style={{
            marginLeft: -inset,
            width: size,
            height: size,
            borderRadius: Math.round(size * 0.27),
            background: 'var(--surface-3)',
            border: '1.5px solid var(--surface-1)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'var(--font-body)',
            fontSize: Math.round(size * 0.42),
            fontWeight: 600,
            color: 'var(--text-2)',
          }}
        >
          +{overflow}
        </span>
      )}
    </span>
  );
}
